import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FormGroup from '../../../../components/global/FormGroup';
import Button from '../../../../components/global/Button';
import { getFormikTouchedErrors } from '../../../../util/formik';
import Select from '../../../../components/global/Select';
import { PRO_REGISTRATION_PERSONAS } from '../helpers';
import { sortArrayByKey } from '../../../../util/sorting';
import { ACCOUNT_PRO_ROLES } from '../../../../constants/account-roles';

const propTypes = {
  className: PropTypes.string,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  requiresCreditCard: PropTypes.bool.isRequired,
};

const RegisterViewDetailsForm = ({
  className,
  handleSubmit,
  values,
  errors,
  touched,
  loading,
  handleChange,
  handleBlur,
  requiresCreditCard,
}) => {
  const classes = classNames({
    'view-register-form': true,
    [className]: !!className,
  });
  const errorList = Object.values(
    getFormikTouchedErrors(errors, touched) ?? {},
  );
  const sortedPersonas = sortArrayByKey(PRO_REGISTRATION_PERSONAS, 'label');

  return (
    <form className={classes} onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-lg-6 col-12">
          <FormGroup
            id="first_name"
            name="first_name"
            label="First name"
            labelSrOnly
            placeholder="First name"
            required
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.first_name}
          />
        </div>
        <div className="col-lg-6 col-12">
          <FormGroup
            id="last_name"
            name="last_name"
            label="Last name"
            labelSrOnly
            placeholder="Last name"
            required
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.last_name}
          />
        </div>
        <div className="col-lg-6 col-12">
          <FormGroup
            id="username"
            name="username"
            label="Username"
            labelSrOnly
            placeholder="Username"
            required
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.username}
          />
        </div>
        <div className="col-lg-6 col-12">
          <FormGroup
            id="organization_name"
            name="organization_name"
            label="Company name"
            labelSrOnly
            placeholder="Company name"
            required
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.organization_name}
          />
        </div>
        <div className="col-lg-6 col-12">
          <FormGroup
            id="email_address"
            name="email_address"
            label="Email address"
            labelSrOnly
            placeholder="Email address"
            required
            type="email"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email_address}
          />
        </div>
        <div className="col-lg-6 col-12">
          <FormGroup
            id="password"
            name="password"
            label="Password"
            labelSrOnly
            placeholder="Password"
            required
            type="password"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
          />
        </div>
        <div className="col-12">
          <Select
            id="persona"
            name="persona"
            label="Choose the persona that fits best to you"
            labelSrOnly
            placeholder="I'm a..."
            required
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.persona}
          >
            <option value="">I&rsquo;m a&hellip;</option>
            {[
              ...sortedPersonas,
              {
                label: 'Other',
                value: 'other',
                role: ACCOUNT_PRO_ROLES.PHOTOGRAPHER,
              },
            ].map(proRegistrationPersona => {
              return (
                <option
                  key={proRegistrationPersona.value}
                  value={proRegistrationPersona.value}
                >
                  {proRegistrationPersona.label}
                </option>
              );
            })}
          </Select>
        </div>
      </div>

      {errorList?.length > 0 && (
        <ul className="mb-2 text-danger">
          {errorList.map(error => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      )}

      <div className="text-center">
        <Button type="submit" disabled={loading} loading={loading}>
          {/* eslint-disable-next-line no-nested-ternary */}
          {loading
            ? 'Processing...'
            : requiresCreditCard
            ? 'Continue'
            : 'Get Started Now'}
        </Button>
      </div>

      {!requiresCreditCard && (
        <p className="text-center mt-1 mb-0">
          <span className="d-block text-sm">No credit card required</span>
        </p>
      )}
    </form>
  );
};

RegisterViewDetailsForm.propTypes = propTypes;

export default RegisterViewDetailsForm;
